export class MontlyMisInfoReq{
    month : number
    year : number
    plantId : number

    constructor(month : number,year : number,plantId : number){
        this.month = month
        this.year = year
        this.plantId = plantId
    }
}